// import Input from "../components/Login/Input";
import axios from "../api/axios";
import { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import roadesenseImage from "../images/roadsense_logo_new.png";

import useConfig from "../hooks/useConfig";
import useAuth from "../hooks/authenticate/useAuth";
import { LoginForm } from "../components/ui/login-form"
import image from "../images/RoadSense_LoginImage.png"
const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const website = window.location.hostname;
  const [isSucceed, setIsSucceed] = useState(false);
  const from = location.state?.from?.pathname || "/";
  const userRef = useRef();
  const errRef = useRef();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const { config, dispatch: confDispatch } = useConfig();
  const { dispatch: authDispatch } = useAuth();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      await axios
        .post(
          `/v1/login`,
          JSON.stringify({
            user: user,
            password: password,
            location: website,
          }),
          {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const auth = {
              isLoggedIn: true,
              token: res.data.token,
              roles: res.data.role,
            };
            authDispatch({ type: "SET_LOGIN", auth: auth });
            confDispatch({ type: "SET_CONFIG", config: res.data.config });
            setUser("");
            setPassword("");
            setTimeout(() => {
              setIsSucceed(true);
            }, 400);
          }
          if (res.status === 204) {
            setUser("");
            setPassword("");
            setErrMsg("user or password are incorrect");
          }
        })
        .catch((err) => {
          console.log(err);
          const msg = err.response?.data?.message || err.message || "Login failed";
          setErrMsg(msg);
          setUser("");
          setPassword("");
        });
    } catch (error) {}
  };
  if (isSucceed && config) {
    if (config["pages"]["statistics"]["show"])
      return <Navigate to={"/"} replace />;
    else {
      let pages = Object.keys(config["pages"]);
      let namepage = "";
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        if (config["pages"][page]["show"]) {
          namepage = page;
          break;
        }
      }
      return <Navigate to={`/${namepage}`} replace />;
    }
  }
  return (
    // <div className="h-full w-full bg-login bg-no-repeat bg-cover bg-clip-padding bg-transparent   ">
    //   <div className="w-full h-full flex items-center justify-center">
    //     <div className="border-2 rounded-2xl flex flex-col items-center py-8 bg-gray-200 opacity-95 justify-center px-20 ">
    //       <div className="pb-5">
    //         <h1 className="">
    //           {
    //             // eslint-disable-next-line jsx-a11y/alt-text
    //             <img className="max-h-8 max-w-xl flex" src={roadesenseImage} />
    //           }
    //         </h1>
    //       </div>
    //       <form className="w-full h-full " onSubmit={onSubmitForm}>
    //         <div className="grid grid-flow-row place-items-center pb-3 ">
    //           <div className="flex flex-col p-2 pr-24 items-center">
    //             <div className="flex flex-row">
    //               <label
    //                 htmlFor="username"
    //                 className="text-base text-center bg-transparent  px-3  self-center text-black flex"
    //               >
    //                 Username:
    //               </label>
    //               <input
    //                 type={"text"}
    //                 name="username"
    //                 ref={userRef}
    //                 autoComplete="off"
    //                 onChange={(e) => setUser(e.target.value)}
    //                 value={user}
    //                 required
    //                 className="h-8 w-44 border-2 text-center  outline-none  focus:border-sky-600 border-transparent border-opacity-30 opacity-80  rounded-lg shadow-md bg-opacity-80  focus:border-transparent    "
    //               />
    //             </div>
    //             <div className="flex flex-row  px-11 py-4">
    //               <label
    //                 htmlFor="password"
    //                 className="text-base text-center bg-transparent px-3 self-center  text-black flex"
    //               >
    //                 Password:
    //               </label>
    //               <input
    //                 type={"password"}
    //                 name="password"
    //                 value={password}
    //                 required
    //                 onChange={(e) => setPassword(e.target.value)}
    //                 className="h-8 w-44 border-2 text-center  outline-none  focus:border-sky-600 border-transparent border-opacity-30 opacity-80  rounded-lg shadow-md bg-opacity-80  focus:border-transparent   "
    //               />
    //             </div>
    //             <div className="flex justify-center pl-24 ">
    //               <p ref={errRef} className="text-sm py-2 text-red-600">
    //                 {errMsg}
    //               </p>
    //             </div>
    //           </div>

    //           <div className="flex flex-row ">
    //             <button className=" w-20 px-3  text-gray-800 bg-white hover:bg-sky-200 border-2 hover:border-sky-700 focus:border-sky-700  text-justify rounded-xl shadow-md bg-opacity-80">
    //               Submit
    //             </button>
    //             {/* <div className="flex items-center px-6">
    //               <input
    //                 className="w-5 h-5  accent-sky-400/100 rounded-lg ring-2  focus:ring-2 ring-sky-400 ring-opacity-40 focus:ring-sky-400 focus:ring-offset-2 focus:ring-offset-sky-200 focus:outline-offset-2 bg-opacity-60 "
    //                 type={"checkbox"}
    //                 id="sky-checkbox"
    //                 value={""}
    //               />
    //               <label
    //                 htmlFor="sky-checkbox"
    //                 className="pl-2 text-sm font-medium"
    //               >
    //                 Keep me Logged in
    //               </label>
    //             </div> */}
    //           </div>
    //         </div>
    //       </form>
    //     </div>
    //   </div>
    // </div>
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="p-6">
        <div className="flex items-center gap-2">
          {/* <Square className="h-5 w-5" /> */}
          {/* <span className="font-medium">Acme Inc.</span> */}
          <img className="max-h-8 max-w-xl flex" src={roadesenseImage} />
        </div>
        <div className="flex h-[calc(100vh-80px)] items-center justify-center">
          <LoginForm setUser={setUser} user={user} password={password} setPassword={setPassword} onSubmit={onSubmitForm} userRef={userRef} errMsg={errMsg} errRef={errRef} />
        </div>
      </div>
      <div className="hidden lg:block bg-[#F3F4F6]">
        <img
          src={image}
          alt="Login cover"
          width={1024}
          height={1024}
          className="h-full w-full h-[100vh] object-cover"
        />
      </div>
    </div>
  );
};
export default Login;
